(function () {
  'use strict';

  function initializeExplorer(root) {
    if (!root || root.getAttribute('data-bpc-ready') === 'true') return;

    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-bpc-cord-button]'));
    var labels = Array.prototype.slice.call(root.querySelectorAll('[data-cord-label]'));
    var detail = root.querySelector('[data-bpc-detail-content]') || root.querySelector('[data-bpc-cord-detail]');
    var family = root.querySelector('[data-bpc-detail-family]');
    var title = root.querySelector('[data-bpc-detail-title]');
    var size = root.querySelector('[data-bpc-detail-size]');
    var description = root.querySelector('[data-bpc-detail-description]');
    var bestFor = root.querySelector('[data-bpc-detail-best]');
    var link = root.querySelector('[data-bpc-detail-link]');
    var pinnedButton = null;

    if (!buttons.length || !family || !title || !size || !description || !bestFor || !link) return;

    function selectCord(button) {
      var cordId = button.getAttribute('data-cord-id');

      buttons.forEach(function (candidate) {
        candidate.setAttribute('aria-pressed', candidate === button ? 'true' : 'false');
      });

      labels.forEach(function (label) {
        if (label.getAttribute('data-cord-label') === cordId) {
          label.classList.add('is-active');
        } else {
          label.classList.remove('is-active');
        }
      });

      family.textContent = button.getAttribute('data-cord-family') || '';
      title.textContent = button.getAttribute('data-cord-title') || '';
      size.textContent = button.getAttribute('data-cord-size') || '';
      description.textContent = button.getAttribute('data-cord-description') || '';
      bestFor.textContent = button.getAttribute('data-cord-best-for') || '';
      link.href = button.getAttribute('data-cord-href') || '#';
      link.textContent = 'Shop ' + (button.getAttribute('data-cord-title') || 'this cord') + ' ↗';

      if (detail) {
        detail.setAttribute('aria-label', 'Details for ' + (button.getAttribute('data-cord-title') || 'selected cord'));
        detail.classList.remove('is-entering');
        void detail.offsetWidth;
        detail.classList.add('is-entering');
      }
    }

    buttons.forEach(function (button) {
      button.addEventListener('mouseenter', function () {
        if (!pinnedButton) selectCord(button);
      });
      button.addEventListener('focus', function () { selectCord(button); });
      button.addEventListener('click', function () {
        pinnedButton = button;
        root.setAttribute('data-bpc-selection-locked', 'true');
        selectCord(button);
      });
    });

    var initial = root.querySelector('[data-bpc-cord-button][aria-pressed="true"]') || buttons[0];
    selectCord(initial);
    root.setAttribute('data-bpc-ready', 'true');
  }

  function initializeChatCallout(callout) {
    if (!callout || callout.getAttribute('data-bpc-chat-ready') === 'true') return;

    var toggle = callout.querySelector('[data-bpc-chat-options-toggle]');
    var optionsId = toggle ? toggle.getAttribute('aria-controls') : '';
    var options = optionsId ? document.getElementById(optionsId) : null;

    if (!toggle || !options) return;

    toggle.addEventListener('click', function () {
      var shouldOpen = toggle.getAttribute('aria-expanded') !== 'true';

      toggle.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
      options.hidden = !shouldOpen;

      if (shouldOpen) {
        window.dispatchEvent(new CustomEvent('bpc:chat-requested'));
      }
    });

    callout.setAttribute('data-bpc-chat-ready', 'true');
  }

  function initializeLogoRail(rail) {
    if (!rail || rail.getAttribute('data-bpc-logo-ready') === 'true') return;

    var track = rail.querySelector('[data-bpc-logo-track]');

    if (!track) return;

    var isDragging = false;
    var activePointerId = null;
    var dragStartX = 0;
    var dragStartScroll = 0;
    var dragMoved = false;
    var suppressClick = false;
    var pauseTimer = null;

    function pauseTemporarily(milliseconds) {
      rail.classList.add('is-paused');
      window.clearTimeout(pauseTimer);
      pauseTimer = window.setTimeout(function () {
        rail.classList.remove('is-paused');
      }, milliseconds);
    }

    rail.addEventListener('wheel', function () { pauseTemporarily(2800); }, { passive: true });
    rail.addEventListener('scroll', function () { pauseTemporarily(1800); }, { passive: true });
    rail.addEventListener('dragstart', function (event) { event.preventDefault(); });

    rail.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'touch') return;
      if (event.pointerType === 'mouse' && event.button !== 0) return;

      isDragging = true;
      activePointerId = event.pointerId;
      dragMoved = false;
      dragStartX = event.clientX;
      dragStartScroll = rail.scrollLeft;
      rail.classList.add('is-dragging');

      if (rail.setPointerCapture) {
        try { rail.setPointerCapture(event.pointerId); } catch (error) {}
      }
    });

    rail.addEventListener('pointermove', function (event) {
      if (!isDragging || event.pointerId !== activePointerId) return;

      var distance = event.clientX - dragStartX;
      if (Math.abs(distance) > 4) {
        dragMoved = true;
        if (event.cancelable) event.preventDefault();
      }
      rail.scrollLeft = dragStartScroll - distance;
    });

    function finishDrag(event) {
      if (!isDragging) return;

      isDragging = false;
      activePointerId = null;
      suppressClick = dragMoved;
      rail.classList.remove('is-dragging');
      pauseTemporarily(2400);

      if (rail.hasPointerCapture && rail.hasPointerCapture(event.pointerId)) {
        rail.releasePointerCapture(event.pointerId);
      }
    }

    rail.addEventListener('pointerup', finishDrag);
    rail.addEventListener('pointercancel', finishDrag);
    rail.addEventListener('lostpointercapture', finishDrag);
    rail.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;

      event.preventDefault();
      pauseTemporarily(2800);
      rail.scrollBy({ left: event.key === 'ArrowLeft' ? -260 : 260, behavior: 'smooth' });
    });
    rail.addEventListener('click', function (event) {
      if (!suppressClick) return;
      event.preventDefault();
      event.stopPropagation();
      suppressClick = false;
    }, true);

    rail.setAttribute('data-bpc-logo-ready', 'true');
  }

  function initializeAll(scope) {
    var parent = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.forEach.call(parent.querySelectorAll('[data-bpc-cord-explorer]'), initializeExplorer);
    Array.prototype.forEach.call(parent.querySelectorAll('[data-bpc-chat-callout]'), initializeChatCallout);
    Array.prototype.forEach.call(parent.querySelectorAll('[data-bpc-logo-rail]'), initializeLogoRail);
    if (parent.matches && parent.matches('[data-bpc-cord-explorer]')) initializeExplorer(parent);
    if (parent.matches && parent.matches('[data-bpc-chat-callout]')) initializeChatCallout(parent);
    if (parent.matches && parent.matches('[data-bpc-logo-rail]')) initializeLogoRail(parent);
  }

  function boot() {
    initializeAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });
}());
